import { PlatformAppsApiClient } from '@fourthwall/services/dist/PlatformAppsApiClient';
import { createMutationHook } from '@fourthwall/utils/dist/queries';
import { useQueryClient } from '@tanstack/react-query';
const publishPlatformApp = (params) => {
    return PlatformAppsApiClient.publishPlatformApp(params);
};
const usePublishPlatformAppMutation = createMutationHook(publishPlatformApp, {
    mutationKey: ['publishPlatformApp'],
});
export const usePublishPlatformApp = () => {
    const queryClient = useQueryClient();
    const { publishPlatformAppMutation } = usePublishPlatformAppMutation({
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['platformAppClients'] });
            queryClient.invalidateQueries({ queryKey: ['platformAppClient'] });
        },
    });
    return {
        publishPlatformApp: publishPlatformAppMutation.mutate,
        isLoading: publishPlatformAppMutation.isLoading,
    };
};
